<template>
  <div>
    <div class="newsList oa-layout-content">
      <div v-if="tobIt == 1">
        <div class="newsLsit-header">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="公司新闻" />
          </a-tabs>
          <a-input-search
            class="newsLsit-search"
            placeholder="请输入"
            style="width: 300px"
            @search="onSearch"
          />
        </div>
        <div
          class="newslist-item"
          v-for="(item, i) in newsList.data"
          :key="i"
          @click="goNewsDetial(item)"
        >
          <blank height="15" v-if="i > 1"></blank>
          <div class="newsItem-title">{{ item.title }}</div>
          <!-- <blank height="27"></blank> -->
          <!-- <div class="newItem-cont" v-html="item.content"></div> -->
          <blank height="20"></blank>
          <div class="newsItem-bottom">
            <div class="newsItem-name">
              {{ item.source }}/{{ item.editperson }} 发布
            </div>
            <div class="newsItem-time">{{ item.time }}</div>
          </div>
        </div>

        <!-- <blank height="82"></blank> -->
        <div class="pagination">
          <a-pagination
            :current="page"
            :pageSize="size"
            :default-current="page"
            :total="newsList.count"
            @change="pageChange"
          />
        </div>
      </div>
      <!--公文简报 -->
      <div v-else>
        <div class="newsLsit-header">
          <a-tabs :default-active-key="tobIt" @change="callback">
            <a-tab-pane key="2" tab="公文" />
            <a-tab-pane key="3" tab="简报" />
          </a-tabs>
        </div>
        <div
          class="my-mission-item"
          v-for="(item, i) in newsList.data"
          :key="i"
          @click="goNewsDetial(item)"
        >
          <div class="my-mission-tips">
            {{ item.title }}
          </div>
          <span class="my-mission-time">{{ item.createTime }}</span>
        </div>

        <!-- <blank height="82"></blank> -->
        <div class="pagination" v-if="newsList.data">
          <a-pagination
            :current="page"
            :pageSize="size"
            :default-current="page"
            :total="newsList.data.length"
            @change="pageChange"
          />
        </div>
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
import {
  officialDocumentMyOfficialDocument,
  briefingGetBreiefing,
  briefingCreateWord,
  officialDocumentCreateWord,
  projectApplyCreateWord,
  getTheInformationRelease
} from './api/api'
export default {
  data() {
    return {
      newsList: {},
      tobIt: 1,
      page: 1,
      size: 10
    }
  },
  created() {
    this.tobIt = this.$route.query.tobIt
    this.gain(this.$route.query.tobIt, { page: this.page, size: this.size })
  },
  methods: {
    gain(i, obj) {
      if (i == 1) {
        getTheInformationRelease(obj).then((res) => {
          if (res.data.code == 0) {
            this.newsList = res.data
          }
        })
        return
      }
      if (i == 2) {
        officialDocumentMyOfficialDocument(obj).then((res) => {
          if (res.data.code == 0) {
            this.newsList = res.data.data
          }
        })
        return
      }
      if (i == 3) {
        briefingGetBreiefing(obj).then((res) => {
          if (res.data.code == 0) {
            this.newsList = res.data.data
          }
        })
        return
      }
    },
    callback(key) {
      this.page = 1
      this.tobIt = key
      this.gain(this.tobIt, { page: this.page, size: this.size })
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.gain(this.tobIt, { page: this.page, size: this.size })
    },
    onSearch(value) {
      this.gain(this.tobIt, { title: value, size: this.size, page: 1 })
    },
    goNewsDetial(i) {
      //新闻
      if (this.tobIt == 1) {
        this.$router.push({
          path: '/newsDetial',
          query: {
            id: i.id
          }
        })
        return
      }
      if (this.tobIt == 2) {
        // 公文
        if (i.skipPageReqFlag == '/OfficialDocumentDetial') {
          //公文模块
          officialDocumentCreateWord({ id: i.documentId, workbench: 1 }).then(
            (res) => {
              if (res.data.code == 0) {
                // 查看
                let item = res.data.data
                if (item.fileformat == 'bpmn') {
                  this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
                } else {
                  let Base64 = require('js-base64').Base64
                  window.open(
                    item.kkFileUrl +
                      encodeURIComponent(Base64.encode(item.fileUrl))
                  )
                }
              }
            }
          )
        } else if (i.skipPageReqFlag == '/ProjectApplicationDetial') {
          //项目申请模块
          projectApplyCreateWord({ id: i.documentId, workbench: 1 }).then(
            (res) => {
              if (res.data.code == 0) {
                // 查看
                let item = res.data.data
                if (item.fileformat == 'bpmn') {
                  this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
                } else {
                  let Base64 = require('js-base64').Base64
                  window.open(
                    item.kkFileUrl +
                      encodeURIComponent(Base64.encode(item.fileUrl))
                  )
                }
              }
            }
          )
        } else if (i.skipPageReqFlag == '/InformTheForwardingDetial') {
          //公文转发模块
          this.$router.push({
            path: '/InformTheForwardingDetial',
            query: {
              id: i.documentId,
              workbench: 1,
              isEdit: 1
            }
          })
        }
        return
      }
      if (this.tobIt == 3) {
        // 简报
        briefingCreateWord({ id: i.documentId, workbench: 1 }).then((res) => {
          if (res.data.code == 0) {
            // 查看
            let item = res.data.data
            if (item.fileformat == 'bpmn') {
              this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
            } else {
              let Base64 = require('js-base64').Base64
              window.open(
                item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
              )
            }
          }
        })
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.newsList {
  .newsLsit-header {
    position: relative;
    .newsLsit-search {
      position: absolute;
      top: 0;
      right: 20px;
    }
  }
  .newslist-item {
    padding: 0 15px 15px 15px;
    border-bottom: #e9e9e9 1px solid;
    cursor: pointer;
    .newsItem-title {
      height: 24px;
      left: 317px;
      top: 220px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 24px;
      text-align: left;
    }
    .newItem-cont {
      width: 678px;
      height: 46px;
      color: rgba(29, 20, 20, 0.65);
      font-size: 14px;
      line-height: 23px;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .newsItem-bottom {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .newsItem-logo {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
      .newsItem-name {
        height: 22px;
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        line-height: 22px;
      }
      .newsItem-time {
        margin-left: 20px;
        height: 22px;
        color: rgba(0, 0, 0, 0.25);
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
}
.my-mission-item {
  padding: 0 50px 10px 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  cursor: pointer;
  .my-mission-tips {
    width: 500px;
    height: auto;
    overflow: hidden;
    color: #808080;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .my-mission-time {
    width: 150px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/workbench/newsList.vue